/**
 * State manager is the functionality to collapse the hidden sections of the
 * above the fold replacing the hero section.
 */
import jQuery from 'jquery';

export default {
  $sections: null,

  /**
   * This will be called only when we do a section toggle/swap. If user clicks
   * a section that is being shown, no state toggling happens and this callback
   * won't be called.
   */
  onHeroSectionToggled: null,

  init(options = {}) {
    this.$sections = jQuery('#hire')
      .add('#work')
      .add('#login')
      .add('#signup')
      .add('#post-project')
      .add('#hire-grid')
      .add('#home-banner');
    this.onHeroSectionToggled = options.onHeroSectionToggled || (() => {});

    this.toggle_bt_init();
  },

  toggle_section($section) {
    jQuery('html,body')
      .animate({ scrollTop: 0 }, { queue: true, duration: 300 }, 'swing')
      .find(this.$sections)
      .filter(':visible')
      .addClass('hidden')
      .removeClass('visible')
      .css('opacity', 1)
      .slideUp(300)
      .animate({ opacity: 0 }, { queue: false, duration: 300 }, 'swing');

    $section
      .removeClass('hidden')
      .css('opacity', 0)
      .slideDown(300)
      .animate({ opacity: 1 }, { queue: false, duration: 300 }, 'swing')
      .addClass('visible');
  },

  toggle_bt_init() {
    const self = this;

    jQuery('[data-section-toggle]').on('click', function(event) {
      const targetAttr = jQuery(this).attr('data-section-toggle');
      const $target = jQuery(`#${targetAttr}`);

      // Return early if the desired section is already shown
      if (!$target.is(':hidden')) {
        return;
      }

      self.toggle_section($target);
      jQuery('.HomeHero-section').toggleClass(
        'is-HomeHero-hidden',
        targetAttr !== 'home-banner',
      );

      setTimeout(() => {
        const homeHeroEl = document.querySelector('.HomeHero-section');
        if (targetAttr !== 'home-banner') {
          homeHeroEl.classList.add('is-HomeHeroLogo-hidden');
        } else {
          homeHeroEl.classList.remove('is-HomeHeroLogo-hidden');
        }
      }, 300);

      // ABTest: CTS-1000
      // Changes on the styling of the button to accommodate background
      // change.
      const headerPostProjectButton = document.getElementById(
        'header-post-project',
      );
      if (headerPostProjectButton) {
        if (targetAttr === 'home-banner') {
          headerPostProjectButton.classList.remove('btn-plain');
          headerPostProjectButton.classList.add('btn-plain-alt');
        } else {
          headerPostProjectButton.classList.add('btn-plain');
          headerPostProjectButton.classList.remove('btn-plain-alt');
        }
      }

      self.onHeroSectionToggled(event);
    });
  },
};
